import { isDefined } from "../utils";
import { MFI as defaultOptions } from "./defaultOptionsForComputation";

export default function () {
  let options = defaultOptions;

  function calculator(data) {
    const { windowSize } = options;

    if (!data || data.length < windowSize + 1) {
      return [];
    }

    const len = data.length;
    const results = new Array(len);

    // Arrays to store positive and negative money flow
    const posMoneyFlow = [];
    const negMoneyFlow = [];

    for (let i = 0; i < len; i++) {
      const bar = data[i];

      // Need valid OHLCV data
      if (
        !bar ||
        !isDefined(bar.high) ||
        !isDefined(bar.low) ||
        !isDefined(bar.close)
      ) {
        results[i] = undefined;
        continue;
      }

      // Extract volume
      let vol = bar.volume;
      if (typeof vol === "object" && vol !== null) {
        vol = vol.volume;
      }

      if (!isDefined(vol) || vol <= 0) {
        results[i] = undefined;
        continue;
      }

      // Calculate typical price
      const typicalPrice = (bar.high + bar.low + bar.close) / 3;

      // Calculate money flow for this bar
      if (i > 0 && isDefined(data[i - 1])) {
        const prevBar = data[i - 1];
        if (
          isDefined(prevBar.high) &&
          isDefined(prevBar.low) &&
          isDefined(prevBar.close)
        ) {
          const prevTypicalPrice =
            (prevBar.high + prevBar.low + prevBar.close) / 3;
          const rawMoneyFlow = typicalPrice * vol;

          // Determine if money flow is positive or negative
          if (typicalPrice > prevTypicalPrice) {
            posMoneyFlow.push(rawMoneyFlow);
            negMoneyFlow.push(0);
          } else if (typicalPrice < prevTypicalPrice) {
            posMoneyFlow.push(0);
            negMoneyFlow.push(rawMoneyFlow);
          } else {
            // No change - neither positive nor negative
            posMoneyFlow.push(0);
            negMoneyFlow.push(0);
          }

          // Need at least windowSize values to calculate MFI
          if (posMoneyFlow.length >= windowSize) {
            // Sum last windowSize periods
            let sumPosMF = 0;
            let sumNegMF = 0;

            for (
              let j = posMoneyFlow.length - windowSize;
              j < posMoneyFlow.length;
              j++
            ) {
              sumPosMF += posMoneyFlow[j];
              sumNegMF += negMoneyFlow[j];
            }

            // Calculate MFI
            if (sumNegMF === 0) {
              // All positive money flow - MFI is 100
              results[i] = 100;
            } else {
              const moneyRatio = sumPosMF / sumNegMF;
              results[i] = 100 - 100 / (1 + moneyRatio);
            }
          } else {
            results[i] = undefined;
          }
        } else {
          results[i] = undefined;
        }
      } else {
        results[i] = undefined;
      }
    }

    return results;
  }

  calculator.undefinedLength = function () {
    return options.windowSize;
  };

  calculator.options = function (x) {
    if (!arguments.length) {
      return options;
    }
    options = { ...defaultOptions, ...x };
    return calculator;
  };

  return calculator;
}
